import { useNavigation } from "@luce/core/adapters/navigation";
import { Card, Icon } from "@luce/ui";

import { serviceReportPdfPath } from "../constant";
import { useVisitServiceReport } from "../gqlhooks";

function tokenFromUrl(url: string) {
  try {
    return new URL(url).searchParams.get("token");
  } catch {
    return null;
  }
}

export type ServiceReportCardProps = {
  visitId?: string;
  visitToken?: string | null;
  onOpen?: () => void;
};

export function ServiceReportCard({ visitId, visitToken, onOpen }: ServiceReportCardProps) {
  const { push } = useNavigation();
  const serviceReport = useVisitServiceReport({ visitId, visitToken });
  const token = serviceReport?.pdfUrl ? tokenFromUrl(serviceReport.pdfUrl) : null;

  if (!serviceReport?.id || !token) return null;

  const path = serviceReportPdfPath(serviceReport.id, token);

  const handlePress = () => {
    onOpen?.();
    push(path);
  };

  return (
    <Card
      direction="row"
      gap="sm"
      onPress={handlePress}
      accessibilityLabel="Service Report"
      testID="visit-service-report"
      className="md:p-spacing-lg md:gap-spacing-md md:rounded-radius-xl bg-transparent"
    >
      <Card.Action>
        <Icon name="FileText" size={20} weight="fill" className="text-luce-brand-primary" />
      </Card.Action>
      <Card.Header>
        <Card.Title>Service Report</Card.Title>
      </Card.Header>
      <Card.Action>
        <Icon name="CaretRight" size={16} className="text-luce-neutral-foreground-intermediate" />
      </Card.Action>
    </Card>
  );
}
